<h2 matDialogTitle *ngIf="!printMode && viewMode">View job</h2>
<h2 matDialogTitle *ngIf="!printMode !viewMode">Edit job</h2>
<h2 matDialogTitle *ngIf="printMode">Download/print job</h2>

<mat-dialog-content>

  <app-waiting-spinner kind="bar" *ngIf="(state$ | async).pending">Loading Job...</app-waiting-spinner>

  <app-job-details
    *ngIf="!printMode && (data.jobId && (state$ | async).jobData) || !data.jobId"
    [adminMode]="adminMode"
    [defaultUserId]="data.userId"
    [productTypes]="(productState$ | async).products"
    [readOnly]="viewMode"
    [showSubmit]="false"
    [job]="(state$ | async).jobData"
    (onSubmit)="onSubmitForm($event)"
  ></app-job-details>

  <app-printable-job
    *ngIf="printMode"
    [job]="(state$ | async).jobData"
  ></app-printable-job>

  <app-message-panel kind="ERROR" *ngIf="(state$|async).pdfError">{{(state$|async).pdfError}}</app-message-panel>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button *ngIf="!printMode && viewMode" (click)="viewMode = false">Edit</button>
  <button mat-button *ngIf="!printMode && !viewMode" (click)="onSaveClick($event)">Save changes</button>

  <ng-container *ngIf="state$ | async; let state">

    <button mat-button *ngIf="!printMode" (click)="showPrintVersion(state.jobData)">Download/print</button>
    <button mat-button *ngIf="printMode" (click)="hidePrintVersion()">Back</button>

    <a
      mat-button
      *ngIf="printMode && !ieDownloadMode && pdfUrl"
      [href]="pdfUrl"
      [download]="getDownloadFilename(state.jobData)"
    >
      Download
    </a>

    <button
      mat-button
      *ngIf="printMode && ieDownloadMode && pdfUrl"
      (click)="ieDownload(state.jobData)"
    >
      Download
    </button>

    <app-waiting-spinner
      type="spinner"
      [spinnerSize]="25"
      [spinnerStroke]="2.5"
      *ngIf="state.pdfPending"
    >
      Generating PDF...
    </app-waiting-spinner>

  </ng-container>

  <button mat-button *ngIf="printMode" (click)="printView()">Print</button>
  <button mat-button [matDialogClose]="false">Cancel</button>
</mat-dialog-actions>
